import Footer from "../../components/Footer";
import LanImg_2 from "../../assets/img/ourStory.png";
import LanIcon_3 from "../../assets/img/Black.png";
import "../style.css";
import { useParams } from "react-router-dom";
import LanImg_1 from "../../assets/img/cert.png";
import LearnMoreSection from "./LanguageLearnMore";
export default function LanguageCert() {
  const { id } = useParams();
  const learnMoreData = {
    pageName: "LanguageCert",
    heroSection: {
      header1: "LanguageCert for",
      header2: "university entry",
      desc: "LanguageCert is a globally recognised English language proficiency test that can be taken online or at an approved test centre.",
      rightImg: LanImg_1,
    },
    aboutTestSection: {
      img: LanImg_2,
      header: "What is the LanguageCert test?",
      desc1:
        "LanguageCert is an internationally recognised English proficiency test designed to assess your English language abilities in real-world scenarios. This test is accepted by over 2,500 universities and institutions in 100+ countries.",
      desc2:
        "As a student looking to study abroad, you have two main options for LanguageCert exams: LanguageCert Academic: If you’re applying for a course that is degree level or above, you can take the LanguageCert Academic test online or at an approved test centre LanguageCert Academic SELT: If you’re applying for a course below degree level (foundation, pathway, or professional English courses), you can take LanguageCert Academic SELT at a UKVI test centre. Both tests have the same format and content, but the LanguageCert Academic SELT gives you a Unique Reference Number (URN) for your Global visa application.",
    },
    blueCardSection: {},
    differenceSection: {
      header: "What makes LanguageCert tests different?",
      desc: "LanguageCert exams offer flexible test options for international students to showcase their English language proficiency to universities and immigration authorities",
      cards: [
        {
          img: LanIcon_3,
          header: "Multiple testing options",
          desc: "You can choose to take the LanguageCert Academic or the Academic SELT test, depending on your requirements",
        },
        {
          img: LanIcon_3,
          header: "Real-world application",
          desc: "The test English proficiency based on everyday situations, helping you develop practical language skills",
        },
        {
          img: LanIcon_3,
          header: "Fast and reliable results",
          desc: "You can get your official LanguageCert score within five working days of completing the test",
        },
        {
          img: LanIcon_3,
          header: "Available worldwide",
          desc: "LanguageCert exams are available in over 200 countries and territories and accepted by institutions in over 100 countries worldwide",
        },
      ],
    },
    testFormatSection: {
      header: "What is a good LanguageCert Academic score?",
      desc: "The LanguageCert scoring system is aligned with the Common European Framework of Reference (CEFR). Here’s a general comparison of LanguageCert Academic scores with IELTS and the CEFR.",
      tableData: {
        rowHeader: ["LanguageCert Academic score", "IELTS score", "CEFR"],
        rowData: [
          {
            column1: "90+",
            column2: "8.5–9.0",
            column3: "C2",
          },
          {
            column1: "75–89",
            column2: "7.8-8.0",
            column3: "C1",
          },

          {
            column1: "60-74",
            column2: "5.5-6.5",
            column3: "B2",
          },
          {
            column1: "40-59",
            column2: "4.0-5.0",
            column3: "B1",
          },
        ],
      },
    },
  };

  return (
    <div className="language-cert">
      <LearnMoreSection learnMoreData={learnMoreData} />

      <div className="language-footer">
        <Footer />
      </div>
    </div>
  );
}
